module.exports = __webpack_public_path__ + "static/media/FinX Terms & Conditions New.0b5ce6ce.pdf";